// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  entityId: __t.u16().primaryKey().name("entity_id"),
  instance: __t.u32(),
  kind: __t.u8(),
  name: __t.string(),
  appearance: __t.u8(),
  level: __t.u8(),
  armor: __t.array(__t.u16()),
});
